import React from 'react'
import { Modal } from 'react-bootstrap'
import Back from 'assets/images/svg/back_blue.svg';
import Countdown from "react-countdown";
import {useTranslation} from "react-i18next";

interface Props {
    show: boolean;
    onHide: () => void;
    expire?: string;
    onResend: () => any
}

const SorryPhoneDialog = ({show, onHide,onResend,expire}  :Props) => {
    const {t} = useTranslation('security');

  return (
    <Modal
    size="lg"
    centered
    show={show}
    onHide={onHide}
    className='all-modal verifyPhoneNumber'
>
    <Modal.Body>
        <div className='header'>
        <img src={Back} alt='back' onClick={onHide}/>
            <h1>{t('sorry')}</h1>
        </div>
        <div className='row'>
            <div className='col-md-12'>
                <p >{t('3-times-tries-block-message')}</p>
            </div>
            <div className='col-12'>
                <Countdown
                    key={expire?.toString() ?? ""}
                    date={expire ?? Date.now()}
                    renderer={(cd) => {
                        return cd.completed ? (
                            <button onClick={onResend} type="button" className="btn-blue">
                                {t('send-again')}
                            </button>
                        ) : (
                            <button type="button" className="btn-blue">
                                {cd.formatted.hours}:{cd.formatted.minutes}:
                                {cd.formatted.seconds}
                            </button>
                        );
                    }}
                />
            </div>

        </div>
    </Modal.Body>
</Modal>
  )
}

export default SorryPhoneDialog